<template>
  <ul class="clickRightMenu"
      id="clickRightMenu">
    <!-- <li v-if="perList.includes('16-1')" @click="menuClick('dataMonitorTable')">{{$t("rightClick.attEquData")}}</li> -->
    <li v-if="perList.includes('16-2')" @click="menuClick('fileManage')">{{$t("rightClick.attachDoc")}}</li>
    <li v-if="perList.includes('16-3')" @click="menuClick('viewFile')">{{$t("rightClick.findRelDoc")}}</li>
    <li v-if="perList.includes('16-4')" @click="menuClick('dwglist')">{{$t("rightClick.viewDraw")}}</li>
    <li v-if="perList.includes('16-5')" @click="menuClick('collectionTree')">{{$t("menu.collect")}}</li>
    <!-- <li v-if="perList.includes('16-6')" @click="menuClick('fixPlan')">{{$t("rightClick.wjxjh")}}</li>
    <li v-if="perList.includes('16-7')" @click="menuClick('testResult')">{{$t("rightClick.jcjg")}}</li>
    <li v-if="perList.includes('16-8')" @click="menuClick('corrosion')">{{$t("rightClick.fsl")}}</li>
    <li v-if="perList.includes('16-9')" @click="menuClick('thick')">{{$t("rightClick.bhcl")}}</li> -->
    <li @click="resetModel('close')">{{$t("rightClick.unsel")}}</li>
  </ul>
</template>
<script>
import ApiService from '@/services/API-services'
export default {
  name: 'contextMenu',
  props: [],
  data() {
    return {
      menushow: true,
      perList: []
    }
  },
  mounted() {
    this.menushow = true
  },
  created() {
    // this.getAuth()
  },
  methods: {
    getAuth() {
      ApiService.user
        .getAuth({
          UserId: JSON.parse(localStorage.user).userId
        })
        .then(res => {
          let a = JSON.parse(res.data[0].PermissionJson)
          let arr1 = []
          for (let i = 0; i < a.length; i++) {
            arr1.push(a[i].code)
            for (let k = 0; k < a[i].child.length; k++) {
              arr1.push(a[i].child[k].code)
            }
          }
          this.$store.commit('setPerList', arr1)
          this.perList = arr1
        })
    },
    menuClick(val) {
      this.$emit('contextMenuClick', { type: 'modal', val: val })
      this.$emit('contextMenuClick', { type: 'op', val: 'close' })
    },
    resetModel(val) {
      this.$emit('contextMenuClick', { type: 'op', val: val })
      window.ResetAllElement()
      window.rightClick = null
    }
  }
}
</script>
<style>
.clickRightMenu {
  width: 159px;
  font-size: 12px;
  position: absolute;
  text-align: left;
  padding: 2px 0;
  border: 1px solid #ccc;
  /* display: none; */
  z-index: 100;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.35);
  font-family: Microsoft YaHei Regular;
}

.clickRightMenu li {
  list-style: none;
  line-height: 28px;
  font-size: 14px;
  text-align: left;
  padding: 5px 30px;
}

.clickRightMenu li:hover {
  background-color: #2d61a8;
  cursor: pointer;
  color: white;
  border-radius: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/contextMenu.vue